import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import Settingspage from './settings';

function Settingscontroller() {
    return[
     
        
        <Topnavbar />,
      
        <Sidennav />,
        <Settingspage />,
    ];
    
}

export default Settingscontroller;